@if (plan(); as plan) {
  <dl class="grid grid-cols-[auto_1fr] items-baseline gap-x-3 gap-y-1.5 text-xs">
    <dt class="text-text-tertiary">{{ 'common.name' | translate }}</dt>
    <dd class="text-text-primary min-w-0 font-medium break-words">{{ plan.name }}</dd>

    @if (plan.parameter?.id) {
      <dt class="text-text-tertiary">{{ 'features.plan.parameters' | translate }}</dt>
      <dd class="text-text-primary min-w-0 break-words">{{ plan.parameter?.name }}</dd>
    }

    @if (plan.solver.id) {
      <dt class="text-text-tertiary">{{ 'features.plan.solver' | translate }}</dt>
      <dd class="text-text-primary min-w-0 break-words">{{ plan.solver.name }}</dd>
    }

    <dt class="text-text-tertiary">{{ 'common.created' | translate }}</dt>
    <dd class="text-text-primary font-mono">
      {{ plan.createdAt | date: 'short' : undefined : currentLang() }}
    </dd>

    @if (plan.parentPlanId; as parentId) {
      <dt class="text-text-tertiary">{{ 'features.plan.parent_plan' | translate }}</dt>
      <dd class="min-w-0">
        @if (parentCommands(); as commands) {
          <a
            data-testid="plan-info-parent-link"
            [routerLink]="commands"
            class="text-accent-main hover:text-accent-hover block cursor-pointer truncate font-mono hover:underline">
            {{ parentId }}
          </a>
        } @else {
          <span class="text-text-primary block truncate font-mono">{{ parentId }}</span>
        }
      </dd>
    }

    <dt class="text-text-tertiary">{{ 'common.status' | translate }}</dt>
    <dd class="flex min-w-0 flex-wrap items-center gap-1.5">
      <span
        data-testid="plan-info-findings"
        class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold"
        [class]="pillClasses[findingsPill().tone]">
        {{ findingsPill().key | translate: findingsPill().params }}
      </span>
      @if (findingsStatus().stale) {
        <span class="bg-info h-2 w-2 shrink-0 rounded-full" aria-hidden="true"></span>
      }
    </dd>

    @if (deployPill(); as deploy) {
      <dt class="text-text-tertiary">
        {{ 'features.plan.deploy.status_detail' | translate }}
      </dt>
      <dd>
        <span
          data-testid="plan-info-deploy"
          class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold"
          [class]="pillClasses[deploy.tone]">
          {{ deploy.key | translate }}
        </span>
      </dd>
    }
  </dl>
}
